import type { OrderStatus } from '@/backend/market'
import type { BranchMiniEntity } from '@/features/branch/domain/entities/BranchMiniEntity'
import type { BrandMiniEntity } from '@/features/brand/domain/entities/BrandMiniEntity'
import type { ItemMiniEntity } from '@/features/item/domain/entities/ItemMiniEntity'
import type { UserMiniEntity } from '@/features/user/domain/entities/UserMiniEntity'
import type { DeliveryStatus } from '../enums/DeliveryStatus'
import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { OrderFulfillmentMethod } from '../enums/OrderFulfillmentMethod'
import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
export class OrderFilterEntity {
  id?: string
  user?: UserMiniEntity
  item?: ItemMiniEntity
  price?: number[]
  branch?: BranchMiniEntity
  brand?: BrandMiniEntity
  startDate?: Date
  endDate?: Date
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
  orderStatus?: OrderStatus
  deliveryStatus?: DeliveryStatus
  fulfillmentMethod?: OrderFulfillmentMethod
  channel?: ChannelMiniEntity
  referenceCode?: string
  regions?: RegionMiniEntity[]
  cursor?: string


}
